import { useTenantInfo } from "@/helpers/hooks";
import KnowledgeBaseUploadV2 from "./KnowledgeBaseUploadV2";
import CreateUpdateKnowledgeSourceV1 from "./CreateUpdateKnowledgeSourceV1";

const CreateUpdateKnowledgeSource = () => {
  const { enableKnowledgeEngine } = useTenantInfo();
  if (enableKnowledgeEngine) {
    return <KnowledgeBaseUploadV2 />;
  }
  return <CreateUpdateKnowledgeSourceV1 />;
};

export default CreateUpdateKnowledgeSource;
